import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The audit log table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen, so a different
 * wording there reads as a different column.
 *
 * Two are locked. `action` is what the row records, so a table without it is a list of timestamps.
 * `details` opens the full row — metadata, state before and after, IP and request id live only
 * there — so hiding it would take the screen's one operation away rather than free up width.
 */
export const AUDIT_LOG_COLUMNS = [
  { id: "index", label: "No." },
  { id: "entityId", label: "Entity ID" },
  { id: "entityType", label: "Entity Type" },
  { id: "action", label: "Event / Action", locked: true },
  { id: "description", label: "Description" },
  { id: "source", label: "Source" },
  { id: "user", label: "User" },
  { id: "occurredAt", label: "Occurred At" },
  { id: "details", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type AuditLogColumnId = (typeof AUDIT_LOG_COLUMNS)[number]["id"];

export const useAuditLogColumnsStore =
  createColumnVisibilityStore<AuditLogColumnId>({
    name: "admin.auditLogs.columns",
    columns: AUDIT_LOG_COLUMNS,
  });
